import {differenceInDays, formatDistance} from "date-fns";
import {ru} from "date-fns/locale";

export function getCurrentUser(state) { return state.currentUser; }

export function getClient(state, clientId) { return state.docsById[clientId]; }
export function getMachine(state, machineId) { return state.docsById[machineId]; }
export function getReport(state, reportId) { return state.docsById[reportId]; }

export function getEngineers(state) { return state.engineers; }
export function getClients(state) { return state.docs.filter(doc => doc.type === "client"); }
export function getMachines(state) { return state.docs.filter(doc => doc.type === "machine"); }
export function getReports(state) { return state.docs.filter(doc => doc.type === "report"); }

export function getClientsById(state) { return Object.fromEntries(getClients(state).map(doc => [doc._id, doc])); }
export function getMachinesById(state) { return Object.fromEntries(getMachines(state).map(doc => [doc._id, doc])); }
export function getReportsById(state) { return Object.fromEntries(getReports(state).map(doc => [doc._id, doc])); }

export function getClientsByIdAsMap(state) { return new Map(getClients(state).map(doc => [doc._id, doc])); }
export function getMachinesByIdAsMap(state) { return new Map(getMachines(state).map(doc => [doc._id, doc])); }
export function getEngineersByIdAsMap(state) { return new Map(getEngineers(state).map(doc => [doc._id, doc])); }

export function getActiveClients(state) {
    const clientsWithMachinesIds = new Set();
    getMachines(state).forEach(machine => clientsWithMachinesIds.add(machine.clientId));

    return getClients(state)
        .filter(client => clientsWithMachinesIds.has(client._id))
        .sort((a, b) => a.name.localeCompare(b.name));
}
export function getActiveMachines(state) { return getMachines(state).filter(machine => machine.clientId); }

export function getClientsWithMachines(state) {
    const clientsById = getClientsById(state);

    for (const clientId in clientsById)
        clientsById[clientId] = {...clientsById[clientId], machines: []};

    const machines = getMachines(state);

    for (const machine of machines) {
        if (machine.clientId) {
            clientsById[machine.clientId].machines.push(machine);
        }
    }

    for (const clientId in clientsById)
        clientsById[clientId].machines.sort((a, b) => a.manufacturer.localeCompare(b.manufacturer) || a.model.localeCompare(b.model));

    return Object.values(clientsById).sort((a, b) => a.name.localeCompare(b.name));
}
export function getMachinesWithClients(state) {
    const clientsById = getClientsById(state);

    for (const clientId in clientsById)
        clientsById[clientId] = {...clientsById[clientId]};

    const machines = getMachines(state).map(machine => ({
        ...machine,
        client: machine.clientId ? clientsById[machine.clientId] : undefined
    }));

    return machines.sort((a, b) => a.manufacturer.localeCompare(b.manufacturer) || a.model.localeCompare(b.model) || a.serial.localeCompare(b.serial));
}


export function getSlotsHistory(reports, clientsById, machinesById) {
    const slotHistoryById = {};

    for (const report of reports) {
        for (const item of report.slotReplacements) {
            if (item.slotMounted && !(item.slotMounted in slotHistoryById)) {
                slotHistoryById[item.slotMounted] = [];
            }
            if (item.slotUnmounted && !(item.slotUnmounted in slotHistoryById)) {
                slotHistoryById[item.slotUnmounted] = [];
            }
        }
    }

    for (const report of reports) {
        let slotReplacements = report.slotReplacements;

        // let unmounts = slotReplacements.filter(item => !item.slotMounted);
        // let mounts = slotReplacements.filter(item => item.slotMounted);
        // slotReplacements = mounts.concat(unmounts);

        for (const item of slotReplacements) {
            if (item.slotMounted) {
                slotHistoryById[item.slotMounted].push({
                    ...item, reportId: report._id, workDate: report.workDate,
                    client: clientsById[report.clientId],
                    machine: machinesById[report.machineId],
                    isMounted: true
                });
            }
            if (item.slotUnmounted) {
                slotHistoryById[item.slotUnmounted].push({
                    ...item, reportId: report._id, workDate: report.workDate,
                    client: clientsById[report.clientId],
                    machine: machinesById[report.machineId],
                    isUnmounted: true
                });
            }
        }
    }

    // -------------------------------------------

    let slotHistoryTable = [];

    for (const [number, history] of Object.entries(slotHistoryById)) {
        if (history.length === 0) {
            continue;  // TODO: this would be an error actually, so throw error?
        }

        const {workDate: firstMentionDate, reportId: firstReportId, client: {name: firstClientName}} = history[0];
        const {workDate: lastMentionDate, reportId: lastReportId, client: {name: lastClientName}} = history.at(-1);

        const daysBetweenMentions = differenceInDays(new Date(lastMentionDate), new Date(firstMentionDate));
        const daysBetweenMentionsStr = formatDistance(new Date(lastMentionDate), new Date(firstMentionDate), {locale: ru});

        const firstMentionState = (number === history[0].slotMounted)
            ? history[0].mountedSlotState
            : "";

        const historyItemsCount = history.length;

        const data = {
            number, firstMentionDate, lastMentionDate, historyItemsCount, daysBetweenMentions,
            daysBetweenMentionsStr, firstMentionState, firstReportId, lastReportId,
            firstClientName, lastClientName
        };

        slotHistoryTable.push(data);
    }

    slotHistoryTable = slotHistoryTable.reverse();

    // -------------------------------------------

    return { slotHistoryTable, slotHistoryById };
}